export default "__VITE_ASSET__B$Xz_piq__"